import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";

export class LPRService {
	constructor(options) {
		this._options = options;
		this._rc = new RealtimeClient();
		this._restClient = new RestClient();
	}

	addWatchlist(name, description = "", callback) {
		const url = "/lpr-app/api/watchlists";
		const body = JSON.stringify({
			name: name,
			description: description
		});
		this._restClient.exec_post(url, body, callback);
	}

	getAllWatchlists(callback) {
		const url = `/lpr-app/api/watchlists`;
		this._restClient.exec_get(url, callback);
	}

	updateWatchlist(id, newName, newDescription, callback) {
		const url = `/lpr-app/api/watchlists/${id}`;
		const body = JSON.stringify({
			name: newName,
			description: newDescription
		});
		this._restClient.exec_put(url, body, callback);
	}

	getWatchlist(id, callback) {
		const url = `/lpr-app/api/watchlists/${id}`;
		this._restClient.exec_get(url, callback);
	}

	deleteWatchlist(id, callback) {
		const url = `/lpr-app/api/watchlists/${id}`;
		this._restClient.exec_delete(url, callback);
	}

	addWatchlistEntry(watchlist, plateNum, state, callback) {
		const url = `/lpr-app/api/watchlists/${watchlist}/entries`;
		const body = JSON.stringify({
			plateNumber: plateNum,
			state: state
		});
		this._restClient.exec_post(url, body, callback);
	}

	addFromCSV(csvText, callback) {
		const url = "/lpr-app/api/watchlists/csv";
		const body = JSON.stringify({
			csv: csvText
		});
		this._restClient.exec_post(url, body, callback);
	}

	getEntriesFromWatchlist(id, callback) {
		const url = `/lpr-app/api/watchlists/${id}/entries`;
		this._restClient.exec_get(url, callback);
	}

	getEntryFromWatchlist(watchlistId, entryId, callback) {
		const url = `/lpr-app/api/watchlists/${watchlistId}/entries/${entryId}`;
		this._restClient.exec_get(url, callback);
	}

	removeAllEntriesFromWatchlist(id, callback) {
		const url = `/lpr-app/api/watchlists/${id}/entries`;
		this._restClient.exec_delete(url, callback);
	}

	removeEntryFromWatchlist(watchlistId, entryId, callback) {
		const url = `/lpr-app/api/watchlists/${watchlistId}/entries/${entryId}`;
		this._restClient.exec_delete(url, callback);
	}
}
